export type ResponseContextData = {
  status: ResponseStatusContext | { [x: string]: boolean };
  message: string;
  data: any;
};

export type ResponseStatusContext = {
  _200_: boolean;
  _204_: boolean;
  _401_: boolean;
  _404_: boolean;
  _500_: boolean;
  _501_: boolean;
};

export enum ProductStatuses {
  _OUT_OF_STOCK_ = '_405_',
  _NOT_SALE_ = '_406_',
  _OUT_OF_QUANTITY_ = '_407_',
}

export const _200_ = 200;

export const _204_ = 204;

export const _401_ = 401;

export const _404_ = 404;

export const _405_ = 405;

export const _406_ = 406;

export const _407_ = 407;

export const _408_ = 408;

export const px = (str: string) => `_${str}_`;

export const ResponseContext = (status: number, message: string, data: any): ResponseContextData => {
  return {
    status: { [px(String(status))]: true },
    message,
    data,
  };
};
